import React from "react";

interface PostStudyAssessmentStepperProps {
  activeTab: "vital_signs" | "laboratory";
  isVitalsSaved?: boolean;
  onStepClick?: (tab: "vital_signs" | "laboratory") => void;
  isEditMode?: boolean;
}

const PostStudyAssessmentStepper: React.FC<PostStudyAssessmentStepperProps> = ({
  activeTab,
  isVitalsSaved = false,
  onStepClick,
  isEditMode = false,
}) => {
  const getStepStatus = (step: number) => {
    if (step === 1) return "active";
    if (step === 2) {
      return activeTab === "laboratory" ? "active" : "inactive";
    }
    return "inactive";
  };

  const handleStepClick = (tab: "vital_signs" | "laboratory", step: number) => {
    if (!onStepClick) return;

    // In edit mode allow free navigation between steps by clicking the stepper
    if (isEditMode) {
      onStepClick(tab);
      return;
    }

    if (step === 1) onStepClick("vital_signs");
    if (step === 2) {
      onStepClick("laboratory");
    }
  };

  const step1Status = getStepStatus(1);
  const step2Status = getStepStatus(2);

  return (
    <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: "12px", border: "1px solid #f1f5f9", padding: "1.25rem 2rem" }}>
      <div className="d-flex align-items-center justify-content-between">
        {/* Step 1 */}
        <div
          className="d-flex align-items-center gap-2"
          onClick={() => handleStepClick("vital_signs", 1)}
          style={{ cursor: isEditMode || isVitalsSaved ? "pointer" : "pointer" }}
        >
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "rgba(6, 182, 212, 0.08)",
              border: "2px solid #06b6d4",
              color: "#06b6d4",
            }}
          >
            <i className="ri-pulse-line"></i>
          </div>
          <span className="fw-semibold" style={{ fontSize: "14px", color: "#06b6d4" }}>
            Vital Signs Measurement
          </span>
        </div>

        {/* Line 1 */}
        <div
          style={{
            flex: 1,
            height: "2px",
            backgroundColor: step2Status === "active" ? "#06b6d4" : "#e2e8f0",
            margin: "0 1rem",
            transition: "background-color 0.3s ease",
          }}
        ></div>

        {/* Step 2 */}
        <div
          className="d-flex align-items-center gap-2"
          onClick={() => handleStepClick("laboratory", 2)}
          style={{
            cursor: isEditMode || isVitalsSaved ? "pointer" : "not-allowed",
            opacity: step2Status === "active" ? 1 : 0.6,
          }}
        >
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: step2Status === "active" ? "rgba(6, 182, 212, 0.08)" : "#f8fafc",
              border: step2Status === "active" ? "2px solid #06b6d4" : "2px solid #e2e8f0",
              color: step2Status === "active" ? "#06b6d4" : "#94a3b8",
              transition: "all 0.3s ease",
            }}
          >
            <i className="ri-flask-line"></i>
          </div>
          <span
            className="fw-semibold"
            style={{
              fontSize: "14px",
              color: step2Status === "active" ? "#06b6d4" : "#64748b",
            }}
          >
            Laboratory Assessment
          </span>
        </div>
      </div>
    </div>
  );
};

export default PostStudyAssessmentStepper;
